import React from "react";
import { Button, Switch, Typography } from "@mui/joy";
import { OrganizationIntegration } from "../../common/types";
import { IntegrationCatalogEntry } from "../../types/integrationCatalog";
import IntegrationCardFrame from "./IntegrationCardFrame";

interface TierCCardProps {
  entry: IntegrationCatalogEntry;
  integration?: OrganizationIntegration;
  enabled: boolean;
  saving?: boolean;
  onToggle: (nextEnabled: boolean) => void;
}

const TierCCard: React.FC<TierCCardProps> = ({
  entry,
  integration,
  enabled,
  saving = false,
  onToggle,
}) => (
  <IntegrationCardFrame
    entry={entry}
    integration={integration}
    enabled={enabled}
    statusLabel={
      enabled
        ? "Enabled"
        : integration?.status === "inactive"
          ? "Disabled"
          : "Not enabled"
    }
    tierBadge="No configuration required"
    preview="This integration is global when enabled. No credentials or organization configuration are required."
    actions={
      <>
        <Typography level="body-sm" color="neutral">
          {enabled ? "Enabled" : "Disabled"}
        </Typography>
        <Switch
          checked={enabled}
          disabled={saving}
          onChange={(event) => onToggle(event.target.checked)}
        />
        {!enabled && (
          <Button
            size="sm"
            variant="solid"
            onClick={() => onToggle(true)}
            disabled={saving}
          >
            Enable
          </Button>
        )}
      </>
    }
  />
);

export default TierCCard;
